import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.timeout = null
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  search(event) {
    // For select elements and date inputs, submit immediately
    if (event.target.tagName === 'SELECT' || event.target.type === 'date' || event.target.type === 'number') {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.element.requestSubmit()
      }, 100)
    } else {
      // For text inputs, use debounce
      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.element.requestSubmit()
      }, 500)
    }
  }
}